/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable react/prop-types */
/* eslint-disable prefer-destructuring */
/* eslint-disable max-len */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import {
  Grid, Snackbar, Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Moment from 'moment';
import Alert from '@material-ui/lab/Alert';
import NoExamDisplay from './NoExamDisplay';
import ExamType3 from './ExamType3';
import ExamType2 from './ExamType2';
import ExamType1 from './ExamType1/indexExam';
import ExamType6 from './ExamType6/indexExam';
import userActions from '../../../../../redux/actions/userActions';
import userServices from '../../../../../redux/services/userServices';
import examResultServices from '../../../../../redux/services/examResultServices';
import Warning from './Warning';
import uiActions from '../../../../../redux/actions/uiActions';
import LandingExamType2 from './ExamType2/LandingExamType2';
import { toastSuccess } from '../../../../../redux/actions/alertActions';
import ExamType5 from './ExamType5';

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
    display: 'flex',
    justifyContent: 'center',
    height: '80vh',
  },
  mainCard: {
    height: '100%',
    minWidth: '45vw',
    position: 'relative',
    overflow: 'visible',
  },
  rise: {
    height: '100rem',
  },
  storyline: {
    minHeight: '75vh',
    maxHeight: '80vh',
  },
  alertContainer: {
    width: '60%',
    marginLeft: '20%',
    textAlign: 'center',
    height: '60vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
}));

const Exam = ({
  userName, currentGroup, userId, groupId, company, changePageTitle, data, userData, email,
}) => {
  const classes = useStyles();
  const [hiddenResults, setHiddenResults] = React.useState(false);
  const [alertAnswer, setAlertAnswer] = React.useState(false);
  const [finished, setFinished] = React.useState(false);
  const [alreadySent, setAlreadySent] = React.useState(false);
  const [started, setStarted] = React.useState(false);
  const [errorSnackBar, setErrorSnackBar] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [answer, setAnswer] = React.useState('');
  const [answerDate, setAnswerDate] = React.useState(null);
  const [currentDate, setCurrentDate] = React.useState(null);
  const [modalMessage, setModalMessage] = React.useState('');
  const [modalApproval, setModalApproval] = React.useState(false);
  const [approval, setApproval] = React.useState(false);
  const [elearningOptions, setElearningOptions] = React.useState([]);
  const [currentExam, setCurrentExam] = React.useState({});
  const [beginDate, setBeginDate] = React.useState(new Date());
  const [examEnd, setExamEnd] = React.useState(new Date());
  const [examFile, setExamFile] = React.useState('');
  const [examType, setExamType] = React.useState(0);
  const [activityId, setActivityId] = React.useState('');
  const [beginExamType2, setBeginExamType2] = useState(false);

  function sortExamsSmart(exams) {
    const now = Date.now();

    const toTime = (v) => {
      const t = new Date(v).getTime();
      return Number.isFinite(t) ? t : NaN;
    };

    const valid = [];
    const invalid = [];

    for (const e of exams) {
      const begin = toTime(e.examBegin);
      const end = toTime(e.examEnd);
      if (Number.isFinite(begin) && Number.isFinite(end)) valid.push({ e, begin, end });
      else invalid.push(e);
    }

    const ongoing = [];
    const past = [];
    const future = [];

    for (const x of valid) {
      if (now >= x.begin && now <= x.end) ongoing.push(x);
      else if (x.begin > now) future.push(x);
      else past.push(x); // (donc end < now si tes données sont cohérentes)
    }

    // Tri internes
    ongoing.sort((a, b) => a.end - b.end); // en cours: finit le plus tôt d'abord
    future.sort((a, b) => a.begin - b.begin); // à venir: début le plus tôt d'abord
    past.sort((a, b) => b.end - a.end); // passés: le plus récent d'abord

    // Choix "tête" entre dernier passé et prochain futur (si pas d'exam en cours en tête)
    const head = [];
    const tail = [];

    // 1) Tous les en cours d'abord
    head.push(...ongoing.map((x) => x.e));

    // 2) Puis on décide qui vient ensuite: last past vs next future
    const lastPast = past[0];
    const nextFuture = future[0];

    if (lastPast && nextFuture) {
      const pastDelta = now - lastPast.end;
      const futureDelta = nextFuture.begin - now;

      if (pastDelta <= futureDelta) {
        head.push(lastPast.e);
        // enlever celui qu’on a mis en tête
        past.shift();
      } else {
        head.push(nextFuture.e);
        future.shift();
      }
    } else if (lastPast) {
      head.push(lastPast.e);
      past.shift();
    } else if (nextFuture) {
      head.push(nextFuture.e);
      future.shift();
    }

    // 3) Le reste : à venir (ordre chronologique), puis passés (du plus récent au plus ancien), puis invalides
    tail.push(...future.map((x) => x.e));
    tail.push(...past.map((x) => x.e));
    tail.push(...invalid);

    return [...head, ...tail];
  }

  const dates = [
    'JANVIER',
    'FEVRIER',
    'MARS',
    'AVRIL',
    'MAI',
    'JUIN',
    'JUILLET',
    'AOUT',
    'SEPTEMBRE',
    'OCTOBRE',
    'NOVEMBRE',
    'DECEMBRE',
  ];

  const getFormatedDate = (_date) => {
    const date = Moment(_date);
    const day = date.date();
    const month = dates[date.month()];
    const year = date.year();
    const hours = date.hours();
    const minutes = date.minutes();

    return `${hours}h${minutes < 10 && minutes > 0 ? '0' : ''}${minutes > 0 ? minutes : ''} le ${day} ${month} ${year}`;
  };

  const loadingExams = async () => {
    let examTypeTemp = 0;
    let examFileTemp = '';
    let examIdTemp = '';
    if (data[currentGroup].elearning.elearningOptions
      && data[currentGroup].elearning.elearningOptions.length > 0) {
      setElearningOptions(data[currentGroup].elearning.elearningOptions);
      const tempElearningOptions = [...data[currentGroup].elearning.elearningOptions];
      let elearningOption;
      tempElearningOptions.forEach((exam) => {
        if (new Date(exam.examBegin) <= new Date() && new Date(exam.examEnd) > new Date()) {
          elearningOption = { ...exam };
        }
      });
      if (!elearningOption) {
        const arr = sortExamsSmart(tempElearningOptions);
        elearningOption = arr[0];
        setCurrentExam(arr[0]);
      } else {
        setCurrentExam(elearningOption);
      }

      setBeginDate(new Date(elearningOption.examBegin));
      const examEndAdditionalTime = new Date(elearningOption.examEnd);
      if (userData.additionalTime && userData.additionalTime > 0) {
        examEndAdditionalTime.setMinutes(examEndAdditionalTime.getMinutes() + userData.additionalTime);
        setExamEnd(examEndAdditionalTime);
      } else {
        setExamEnd(new Date(elearningOption.examEnd));
      }
      if (elearningOption.examSubject !== null) {
        setExamFile(elearningOption.examSubject.examFile);
        setActivityId(elearningOption.examSubject.activityId);
        examTypeTemp = elearningOption.examSubject.type;
        examFileTemp = elearningOption.examSubject.examFile;
        examIdTemp = elearningOption._id;
        setExamType(elearningOption.examSubject.type);
      } else if (elearningOption.examSubject === null) {
        setExamType(0);
        examTypeTemp = 0;
      }
    }
    if (examTypeTemp === 2) {
      const examResult = async () => {
        try {
          const res = await examResultServices.getExamByExamId(examIdTemp, userId);
          return res;
        } catch (e) {
          console.error(e);
        }
      };

      const exam = await examResult();
      if (exam !== undefined && exam !== null) {
        if (exam.answer === undefined || exam.answer === '' || exam.answer === null) {
          setHiddenResults(false);
        } else {
          setHiddenResults(true);
          setAnswerDate(getFormatedDate(new Date(exam.created_at)));
          setAnswer(exam.answer);
          setAlreadySent(true);
        }
      } else {
        if (localStorage.getItem('answer') !== null) {
          setAnswer(JSON.parse(localStorage.getItem('answer')));
        }
        setHiddenResults(false);
      }
    }
    try {
      const resTime = await userServices.getFixTime();
      if (resTime) {
        setCurrentDate(new Date(resTime.today));
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  useEffect(() => {
    changePageTitle('E-Learning | Exam');
    loadingExams();
  }, [data, data[currentGroup], groupId]);

  // sending answer to db
  const sendAnswer = () => {
    examResultServices.postExam({
      companyId: company._id,
      groupId,
      examFile,
      examId: currentExam._id,
      userId,
      answer,
    })
      .then(() => {
        const today = new Date();
        setAnswerDate(getFormatedDate(today));
        setHiddenResults(true);
        localStorage.removeItem('answer');
        toastSuccess('Réponse envoyée');
      })
      .catch(() => {
        setErrorSnackBar({ code: 2001, message: 'Erreur dans l\'envoi de votre réponse', severity: 'error' });
      });
  };

  // tiggering the modals to check if there is an answer AND if the user wants to confirm his answer
  const handleApprovalAnswer = () => {
    if (answer !== undefined && answer !== '') {
      setModalMessage('Etes-vous sûr(e) de vouloir envoyer votre réponse ?');
      setModalApproval(true);
    } else {
      setModalMessage('Vous ne pouvez pas envoyer de réponse vide.');
      setAlertAnswer(true);
    }
  };

  // sending answer depending on approval state
  useEffect(() => {
    if (approval === true) {
      sendAnswer();
    }
    setApproval(false);
  }, [approval]);

  const handleAnswer = (e) => {
    localStorage.setItem('answer', JSON.stringify(e.target.value));
    setAnswer(e.target.value);
  };

  return (
    <div className={classes.root}>
      <Snackbar open={errorSnackBar !== null} onClose={() => { setErrorSnackBar(null); }} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert severity={errorSnackBar !== null ? errorSnackBar.severity : 'info'} variant="filled" onClose={() => { setErrorSnackBar(null); }} role="status">
          {`Error ${errorSnackBar?.code}: ${errorSnackBar?.message}`}
        </Alert>
      </Snackbar>
      {
        loading
          ? (
            <Typography variant="h6" component="h2">
              Loading...
            </Typography>
          )
          : (
            <Grid container direction="column" className={classes.mainCard}>
              {
                // eslint-disable-next-line react/destructuring-assignment
                (elearningOptions
                  && elearningOptions.length > 0
                  && examType !== undefined
                  && (data[currentGroup].semester === userData.semester || (userData.catchUp && userData.catchUp.includes(data[currentGroup].semester))))
                  ? (currentDate && beginDate > currentDate
                    ? (
                      <NoExamDisplay
                        examText="Examen à venir"
                        getFormatedDate={getFormatedDate}
                        examBegin={beginDate}
                        examEnd={examEnd}
                      />
                    )
                    : (currentDate
                      && (
                        (examType !== 1 && examEnd > currentDate)
                        || (examType === 1
                          && ((!finished && started) || (examEnd > currentDate && !started)))
                        || (examType === 2
                          && ((!localStorage.getItem(`examBeginTime_${currentExam._id}`)
                            && examEnd > currentDate)
                            || (localStorage.getItem(`examBeginTime_${currentExam._id}`)
                              && (currentDate.getTime() - new Date(JSON.parse(localStorage.getItem(`examBeginTime_${currentExam._id}`))).getTime()) / 60000 < currentExam.duration))))
                      ? (() => {
                        switch (examType) {
                          case 0:
                            return (
                              <div className={classes.alertContainer}>
                                <Alert severity="info" role="status">
                                  Vous n’avez pas d’épreuve écrite prévue sur la plateforme durant ce semestre. Pour en savoir plus, vous pouvez consulter votre programme dans l’onglet « Resources » ou vous renseigner auprès de votre école.
                                </Alert>
                              </div>
                            );
                          case 7:
                          case 8:
                            return (
                              <ExamType1
                                activityId={activityId}
                                currentExam={currentExam}
                                setFinished={setFinished}
                                setStarted={setStarted}
                              />
                            );
                          case 6:
                            return (
                              <ExamType6
                                activityId={activityId}
                                currentExam={currentExam}
                                setFinished={setFinished}
                                setStarted={setStarted}
                              />
                            );
                          case 2:
                            return (
                              <>
                                {!beginExamType2
                                  ? (
                                    <LandingExamType2
                                      examBegin={beginDate}
                                      beginExamType2={beginExamType2}
                                      setBeginExamType2={setBeginExamType2}
                                      currentExam={currentExam}
                                    />
                                  )
                                  : (
                                    <ExamType2 data={{
                                      examFile,
                                      hiddenResults,
                                      answer,
                                      handleAnswer,
                                      answerDate,
                                      handleApprovalAnswer,
                                      modalApproval,
                                      setModalApproval,
                                      modalMessage,
                                      setApproval,
                                      alertAnswer,
                                      setAlertAnswer,
                                      currentExam,
                                    }}
                                    />
                                  )}
                                {examEnd
                                  && (
                                    <Warning
                                      examEnd={examEnd}
                                      setCurrentDate={setCurrentDate}
                                      getFormatedDate={getFormatedDate}
                                      currentExam={currentExam}
                                      sendAnswer={sendAnswer}
                                      examType={examType}
                                      alreadySent={alreadySent}
                                      setAlreadySent={setAlreadySent}
                                      answerDate={answerDate}
                                    />
                                  )}
                              </>
                            );
                          case 3:
                            return (
                              <ExamType3
                                group={data[currentGroup]}
                                userId={userId}
                                email={email}
                                userName={userName}
                                getFormatedDate={getFormatedDate}
                                examFile={examFile}
                              />
                            );
                          case 4:
                            return (
                              <>
                                {!beginExamType2
                                  ? (
                                    <LandingExamType2
                                      examBegin={beginDate}
                                      beginExamType2={beginExamType2}
                                      setBeginExamType2={setBeginExamType2}
                                      currentExam={currentExam}
                                    />
                                  )
                                  : (
                                    <ExamType2 data={{
                                      examFile,
                                      hiddenResults,
                                      answer,
                                      handleAnswer,
                                      answerDate,
                                      handleApprovalAnswer,
                                      modalApproval,
                                      setModalApproval,
                                      modalMessage,
                                      setApproval,
                                      alertAnswer,
                                      setAlertAnswer,
                                      currentExam,
                                    }}
                                    />
                                  )}
                                {examEnd
                                  && (
                                    <Warning
                                      examEnd={examEnd}
                                      setCurrentDate={setCurrentDate}
                                      getFormatedDate={getFormatedDate}
                                      currentExam={currentExam}
                                      sendAnswer={sendAnswer}
                                      examType={examType}
                                      alreadySent={alreadySent}
                                      setAlreadySent={setAlreadySent}
                                      answerDate={answerDate}
                                    />
                                  )}
                              </>
                            );
                          case 5:
                            return (
                              <ExamType5
                                group={data[currentGroup]}
                                userId={userId}
                                email={email}
                                userName={userName}
                                getFormatedDate={getFormatedDate}
                                examFile={examFile}
                                examId={currentExam._id}
                              />
                            );
                          default:
                            break;
                        }
                      })()
                      : (
                        <NoExamDisplay
                          examText="Votre épreuve est terminée."
                          getFormatedDate={getFormatedDate}
                          examBegin={beginDate}
                          examEnd={examEnd}
                        />
                      )
                    ))
                  : (
                    <div className={classes.alertContainer}>
                      <Alert severity="info" role="status">
                        Vous n’avez pas d’épreuve écrite prévue sur la plateforme durant ce semestre. Pour en savoir plus, vous pouvez consulter votre programme dans l’onglet « Resources » ou vous renseigner auprès de votre école.
                      </Alert>
                    </div>
                  )
              }
            </Grid>
          )
      }
    </div>
  );
};

Exam.propTypes = {
  data: PropTypes.array.isRequired,
  userName: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  currentGroup: PropTypes.number.isRequired,
  groupId: PropTypes.string.isRequired,
  company: PropTypes.object.isRequired,
  changePageTitle: PropTypes.func.isRequired,
};

function mapState(state) {
  const { userData } = state.user;
  const { data } = state.group;
  const { currentGroup } = state.ui;
  const userName = `${userData.name} ${userData.firstname}`;
  const { email } = userData;
  const userId = userData._id;
  const { company } = userData;
  return {
    // eslint-disable-next-line max-len
    data, userName, email, currentGroup, userId, groupId: data[currentGroup]._id, company, userData,
  };
}

const actionCreators = {
  logout: userActions.logout,
  changePageTitle: uiActions.changePageTitle,
};

export default connect(mapState, actionCreators)(Exam);
